// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from "@sentry/browser";

export const SentryEnvironments = {
  Development: "development",
  Production: "production",
};

const initializeSentry = ({ dsn, environment }) => {
  return Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: environment === SentryEnvironments.Development ? 0 : 0.2,
    environment,
    replaysSessionSampleRate:
      environment === SentryEnvironments.Development ? 0 : 0.1,
    replaysOnErrorSampleRate:
      environment === SentryEnvironments.Development ? 0 : 0.1,
    attachStacktrace: true,
  });
};

export { initializeSentry };
